import { render, staticRenderFns } from "./CampanhaVendaMargemFaixas.vue?vue&type=template&id=2c0a2766&scoped=true"
import script from "./CampanhaVendaMargemFaixas.vue?vue&type=script&lang=js"
export * from "./CampanhaVendaMargemFaixas.vue?vue&type=script&lang=js"
import style0 from "./CampanhaVendaMargemFaixas.vue?vue&type=style&index=0&id=2c0a2766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a2766",
  null
  
)

export default component.exports